import styled from 'styled-components';
import moment from 'moment';
import {Dialog, Tab, Tabs, Switch} from '@blueprintjs/core';
import {breakpoints} from '../../styles/variables';
import DateSelector from './date-selector';
import {useState, useEffect} from 'react';
import ThumbnailWithStatelems from '../../services/thumbnailer/thumbnail-with-statelems';

const StyledDialog = styled(Dialog)`
    max-width: var(--widget-max-width);
    width: 60%;
    position: fixed !important; /* Override default centering */
    top: 10% !important; /* Anchor top at 10% of viewport height */
    left: 50% !important; /* Center horizontally */
    transform: translateX(-50%) !important; /* Adjust for horizontal centering */
    margin: 1rem;

    @media (max-width: ${breakpoints.MED_PC_SIZE}) {
        width: 70%;
    }

    @media (max-width: ${breakpoints.SMALL_PC_SIZE}) {
        width: 80%;
    }

    & .bp3-dialog-header {
        border-radius: var(--blueprint-dialog-border-radius) var(--blueprint-dialog-border-radius) 0 0;
    }

    & .bp3-button {
        border-radius: var(--button-border-radius);
    }
`;

const NoThumbnail = styled.div`
    aspect-ratio: 16 / 9;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const LargeImage = styled.img`
    margin: 1rem 1rem 0;
    width: calc(100% - 2rem);
`;

const LargeCanvas = styled.div`
    margin: 1rem 1rem 0;
    //padding-top: 16px;
    width: calc(100% - 2rem);
`;

const StyledContent = styled.div`
    padding: 1rem;
`

const Popup = ({
                   dates,
                   selectedRecording,
                   setSelectedRecording,
                   popupSelectedDate,
                   setPopupSelectedDate,
               }) => {
    const [showElems, setShowElems] = useState(true);
    const [thumbnailsWithStatelems, setThumbnailsWithStatelems] = useState(
        selectedRecording?.thumbnailsWithStatelems || null
    );

    const getSelectedThumbnailURL = (selectedRecording, popupSelectedDate) => {
        if (
            !selectedRecording ||
            typeof selectedRecording !== 'object' ||
            !selectedRecording.thumbnails ||
            !selectedRecording.timezone
        ) {
            return null;
        }

        const selectedThumbnail = selectedRecording.thumbnails.find(
            (thumb) => moment(thumb.local_time).format('L') === popupSelectedDate,
        );
        if (selectedThumbnail && selectedThumbnail.url) {
            return selectedThumbnail.url;
        }

        return null;
    };

    useEffect(() => {
        setThumbnailsWithStatelems(selectedRecording?.thumbnailsWithStatelems || null);
    }, [selectedRecording]);

    return (
        <StyledDialog
            isOpen={selectedRecording}
            onClose={() => {
                setSelectedRecording(null);
            }}
            canOutsideClickClose={true}
            title={selectedRecording ? selectedRecording.name : ''}
        >
            <Switch
                style={{margin: "1rem"}}
                label="Show lines and areas"
                checked={showElems}
                onChange={() => setShowElems(!showElems)}
            />
            <div>
                {showElems
                    ? (
                        <LargeCanvas>
                            <ThumbnailWithStatelems
                                thumbnail={thumbnailsWithStatelems}
                                showTaxonomies={true}
                                interactive={true}
                            />
                        </LargeCanvas>
                    )
                    : (
                        <div>
                            {(() => {
                                const url = getSelectedThumbnailURL(
                                    selectedRecording,
                                    popupSelectedDate,
                                );
                                if (url) {
                                    return (
                                        <LargeImage
                                            loading="lazy"
                                            src={getSelectedThumbnailURL(
                                                selectedRecording,
                                                popupSelectedDate,
                                            )}
                                        />
                                    );
                                }

                                return (
                                    <NoThumbnail>
                                        <span>Image Unavailable</span>
                                    </NoThumbnail>
                                );
                            })()}
                            {dates.length > 1 && (
                                <>
                                    <p></p>
                                    <DateSelector
                                        dates={dates}
                                        selectedDate={popupSelectedDate}
                                        setSelectedDate={setPopupSelectedDate}
                                    />
                                </>
                            )}
                        </div>
                    )
                }
            </div>
        </StyledDialog>
    );
};

export default Popup;
